import React, { useState, useEffect, useRef, useCallback } from 'react'
import { useHistory, useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux'

import {
    AppLayout, HelpPanel, Icon, BreadcrumbGroup, Box, Link, SpaceBetween, Header, Button,
    Container, Spinner, Alert,  Modal,
    ExpandableSection,
    CopyToClipboard,
    StatusIndicator,
    Input,
    Multiselect
} from '@amzn/awsui-components-react';
import SideNav from './SideNav';
import AccessDenied from '../../AccessDenied'
import WaitForPageAccess from '../../WaitForPageAccess'
import './history.scss'
import checkPageAccess, { checkIfPortalAdmin, checkIfSupportAdmin } from "../../checkPageAccess";
import { API, graphqlOperation } from 'aws-amplify';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useAuth } from "../../context/AuthContextProvider";
import { Storage } from 'aws-amplify';
import { setCurrentAppId } from '../../store/userAuthSlice';
import { setRerunData } from '../../store/flexicoRerunSlice';
import { queryFRISCOTransactionsByAppIdProcessIdIndex} from "src/Ateam-BI/Templates/Utils/AppActivityUtils"
import moment from 'moment';
import { FLEXICO_TEMPLATE_KEYS, PROCESS_KEYS } from './Constants';
import { convertEpochToLocal } from '../Frisco/FilterUtilities';
import { configureFlexicoAppSync, configureFlexicoS3, configureFriscoS3, configureGenericS3 } from 'src/context/AuthContextUtility'
import { isApprover, isUploaderAllowed } from './AccessUtilities';
import { getFlexicoTemplate, getFlexicoTransaction, listFlexicoTransactionsByFlexId, listFlexicoTransactionsByFlexIdAll } from 'src/utilities/FlexicoAPIs';
import { getPreference, createPreference, updatePreference, listPreference } from 'src/utilities/AppSyncPlusAPIs';
import { CodeView } from '@amzn/awsui-code-view';
import { v4 as uuidv4 } from 'uuid';
import DownloadableFileListComponent from '../Templates/components/DownloadableFileListComponent';
import useVisibleTimeTracker from 'src/katalMetrics/useVisibleTimeTracker';
import { ACTION_METHODS, METRIC_TYPE, SITE_SERVICES } from 'src/katalMetrics/metricsModels';
import { createKatalTimerStopWatch, stopAndCaptureTimeMetricsWithBasicAttributes} from "src/katalMetrics/metricsHelperMethods"
import { getDisplayName } from '../utils/displayNameUtils';
import appSettings from '../CorpReporting/app_settings';
import { isCorpAdmin, isCorpViewer } from '../Templates/Utils/Permissions';
import { mergeColumnStateAndDef } from 'src/utilities/HistoryUtils';
import { getDocumentFromVault } from 'src/Ateam-BI/Vault/VaultAPIs';
import { VAULT_SERVICES } from "src/Ateam-BI/Vault/constants";

const FlexicoHistory = (props) => {

    const userAuthenticationDetails = useAuth();
    const gridRef = useRef();
    const history = useHistory();
    const dispatch = useDispatch()
    const userLDAPS = userAuthenticationDetails.USER_LDAP_GROUPS;
    const [isCheckingAccess, setIsCheckingAccess] = useState(true);
    const [isAuthorised, setIsAuthorised] = useState(false);
    const [items, setItems] = useState([]);
    const [showLoadingIcon, setShowLoadingIcon] = useState(true);
    const [flexicoTemplateData, setFlexicoTemplateData] = useState({})
    const [transactions, setTransactions] = useState([])
    const [parametersModalData, setParametersModalData] = useState('')
    const currentStage = useSelector((globalState) => globalState.auth.currentStage)
    const userId = useSelector((globalState) => globalState.auth.userId);
    const [parametersVisible, setParametersVisible] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)
    const [hasColumnChanges, setHasColumnChanges] = useState(false)
    const [isInitialLoadComplete, setIsInitialLoadComplete] = useState(false)
    const [isAdminUser, setIsAdminUser] = useState(false)
    const [fullPreferenceObject, setFullPreferenceObject] = useState(null)
    const [displayParameters, setDisplayParameters] = useState([])
    const [displayParamPreferenceObject, setDisplayParamPreferenceObject] = useState(null)
    const prevDisplayParamsRef = useRef({ params: null, templateId: null })
    
    const [isSavingColumnPreferences, setIsSavingColumnPreferences] = useState(false)
    const [columnPreferenceError, setColumnPreferenceError] = useState("")
    const [columnPreferenceSuccess, setColumnPreferenceSuccess] = useState("")
    const [isResetting, setIsResetting] = useState(false)
    const [renameModalObj, setRenameModalObj] = useState(null)
    
    // const isCurrentAppAuthorised = useSelector((globalState) => globalState.auth.isCurrentAppAuthorized)
    const currentAppId = useSelector(
        (globalState) => globalState.auth.currentAppId
      );
    let { id: paramId } = useParams();
    let { fid: paramFid } = useParams();
    
    const id = props.id || paramId;
    const fid = props.fid || paramFid;
    const [backUrl, setBackUrl] = useState(null)

    const ln = useLocation()
    useVisibleTimeTracker([{
            metricName : 'actionPerformedBy',
            metricValue : userId,
            metricType : METRIC_TYPE.STRING,
            isMonitor : true
        },
        {
            metricName : 'pagePath',
            metricValue : `${ln.pathname}`,
            metricType : METRIC_TYPE.STRING,
            isMonitor : true
        }
    ], "timeSpent", ACTION_METHODS.TIME_SPENT_ON_PAGE, SITE_SERVICES.FLEXICO);

    useEffect(() => {
        configureFlexicoAppSync()
        configureFlexicoS3()
        loadData()
        setBackUrl(getParam('back'))
        if(id){
            dispatch(setCurrentAppId(id))
        }
        return () => {
            configureGenericS3()
        };
    }, []);

    useEffect(() => {
        if (fid) {
            loadColumnPreferences(
                (savedState) => {
                    // Only restore saved layout if a valid column state exists
                    if (savedState && savedState.columnState && savedState.columnState.length > 0) {
                        const reorderedCols = savedState.columnState
                            // Exclude hidden columns from the saved state
                            .filter(col => !col.hide)
                            .map(savedCol => {
                                const baseColDef = defaultColumnDefs.find(defCol => defCol.field === savedCol.colId);
                                const savedColDef = savedState.columnDefinition?.find(def => def.field === savedCol.colId);
                                if (baseColDef) {
                                    // Merge saved width/headerName with the base def, but always keep the live cellRenderer
                                    const merged = mergeColumnStateAndDef(baseColDef, savedColDef);
                                    if (merged && baseColDef?.cellRenderer) merged.cellRenderer = baseColDef.cellRenderer;
                                    return merged;
                                }
                                // param_* columns are not in defaultColumnDefs — re-build them using the live valueGetter
                                // so cell rendering uses current template data rather than stale saved definitions
                                if (savedCol.colId?.startsWith('param_')) {
                                    const label = savedCol.colId.replace('param_', '');
                                    const built = buildParamColumnDefs([label], flexicoTemplateData);
                                    return built[0] || null;
                                }
                                return null;
                            })
                            .filter(Boolean);
                        
                        // Append any new default columns that weren't present when the preference was last saved
                        const savedFields = new Set(savedState.columnState.map(col => col.colId));
                        const newCols = defaultColumnDefs.filter(col => !savedFields.has(col.field));
                        setColumnDefs([...reorderedCols, ...newCols]);
                    }
                },
                (error) => {
                    console.error('Error loading column preferences:', error);
                }
            );
            loadDisplayParamPreferences((savedParams) => {
                setDisplayParameters(savedParams);
            });
        }
    }, [fid, flexicoTemplateData]);


    const getS3FolderPath = (item) => {
        let status = item.processingStatus.toLowerCase()
        switch (status) {
            case 'completed': return 'completed';
            case 'pending':
            case 'processing': return 'pending';
            default: return status
        }
    }

    const processIcon = props => (
        props.data.status === 'Completed' ?
            <Box>
                <Icon name='status-positive' variant='success' ></Icon>
            </Box>

            : <Box>
                <Icon name='status-in-progress' variant='normal' ></Icon>
            </Box>


    )

    async function forceDownloadFromUrl(fileURL, fileName) {
        try {
            const response = await fetch(fileURL)
            const blob = await response.blob()
            const blobUrl = window.URL.createObjectURL(blob)
            const a = window.document.createElement('a')
            a.href = blobUrl
            a.download = fileName
            window.document.body.appendChild(a)
            a.click()
            window.URL.revokeObjectURL(blobUrl)
            a.remove()
        } catch (e) {
            // Fallback to window.open if fetch fails (e.g. CORS)
            window.open(fileURL);
        }
    }

    const downloadRawFile= async (item) => {
        configureFlexicoS3()
        let fn = `${item.rawFilePath}`
        let arr = fn.split('.')
        let contentType = arr[arr.length - 1]
        // fn = fn.replace('flexico/','')
        let prefix = 'flexico/'
        /*
        If s3 object name has a space. S3 replaces it with a +. 
        However, if it has a space and +, s3 resolves the space as + hence there is a resolution conflict between + and ' '. 
        S3 also responds with by replacing + as %2B when the file is uploaded via storage. 
        So, we have to replace the + with space and then %2B as + which then creates a correct downloadable key format.
        */
        if(fn.includes('+') && fn.includes('%2B')){
            fn=fn.replaceAll('%2B', 'ABCPLUSTEMP')
        }
        fn=fn.replaceAll('+', ' ')
        // const result = await Storage.get(decodeURIComponent(fn).replaceAll('ABCPLUSTEMP','+'), { level: 'public', customPrefix:{public:prefix}, expires: 60 });
        let vaultDoc = await getDocumentFromVault(contentType, VAULT_SERVICES.FLEXICO, {"file_path": `${decodeURIComponent(fn).replaceAll('ABCPLUSTEMP','+')}`, "service_id":`${fid}`, "app_id":`${id}`})
        let fileURL = vaultDoc?.fileUrl
        const fileName = fn.split('/').pop()?.replaceAll('ABCPLUSTEMP', '+') || 'download'
        await forceDownloadFromUrl(fileURL, fileName);
    }

    // Check if string is null, undefined, or empty
    function isEmpty(str) {
        return (str == null || !str || str.length === 0 || str.trim() === '' || str.trim() === 'null');
    }

    const performDownload = async(fn) => {
        let files = fn.split(',')
        for(let i=0;i<files.length;i++){
            if(isEmpty(files[i])){
                continue
            }
            let filefn = files[i]
            let arr = filefn.split('.')
            let contentType = arr[arr.length - 1]
            let prefix = 'flexico/'
            // const result = await Storage.get(filefn, { level: 'public', customPrefix:{public:prefix}, expires: 60 });
            let vaultDoc = await getDocumentFromVault(contentType, VAULT_SERVICES.FLEXICO, {"file_path": `${filefn}`, "service_id":`${fid}`, "app_id":`${id}`})
            let fileURL = vaultDoc?.fileUrl
            const fileName = filefn.split('/').pop() || 'download'
            await forceDownloadFromUrl(fileURL, fileName);
        }
    }
    const downloadFile = async (item, key) => {
        configureFlexicoS3()
        let fn = `${item[key]}`
        performDownload(fn)
    }

    const downloadFileFromJSON = async (item, key) => {
        configureFlexicoS3()
        let results = item[key]
        let uris = []
        for(let i=0;i<results.length;i++){
            let opRef = JSON.parse(results[i])
            uris.push(opRef?.uri)
        }
        let uriString = uris.join(',')
        performDownload(uriString)
        
    }

    const gotoDetails = (data) => {
        history.push(`/flexico/file/${data.fileId}`)
        
    }
    
    const downloadIcon = props => (
        <>{
            (props.data.bucketName && props.data.filePath) ? <SpaceBetween size='m' direction='horizontal'>
                <ExpandableSection headerText={<Box>Download</Box>}
                    headerActions={
                        <Button
                            variant="inline-link"
                            onClick={() => {
                                    downloadFile(props.data, 'filePath')
                                }
                            }
                        >
                            All
                        </Button>
                    }
                >
                    <DownloadableFileListComponent filePaths={props?.data.filePath.split(',')} bucketName={props?.data.bucketName} serviceId={fid} appId={id}></DownloadableFileListComponent>
                </ExpandableSection>
                <>
                {
                    props.data.rawFilePath ?
                     <Button
                variant='inline-link'
                onClick={() => {
                    downloadRawFile(props.data)
                }
                }> [Raw file] </Button>
                : ''
                }</>
            </SpaceBetween>:
            <></>
        }</>
    )

    const outputIcon = props => {
        let s3DownloadCount = 0
        let isQSReport = false
        if(props.data.bucketName && props.data.outputResultsS3){
            s3DownloadCount = s3DownloadCount + props.data.outputResultsS3.split(",").length
        }
        if(props.data.outputResults){
            for(let i=0;i<props.data.outputResults.length;i++){
                let data = JSON.parse(props.data.outputResults[i])
                if(data.type == 'S3'){
                    s3DownloadCount = s3DownloadCount + 1
                }else if(data.type == 'QUICKSIGHT'){
                    isQSReport=true
                }
            }
        }
        return <SpaceBetween direction='horizontal' size='s'> 
        {
            s3DownloadCount > 0 && 
            <ExpandableSection headerText={<Box>Download</Box>}
                    headerActions={
                        <Button
            variant='inline-link'
            onClick={() => {
                downloadFile(props.data, 'outputResultsS3')
                downloadFileFromJSON(props.data, 'outputResults')
            }
            }> All </Button>
                    }
                >
                    <DownloadableFileListComponent filePaths={props?.data?.outputResultsS3?.split(",")} bucketName={props?.data.bucketName} filePathsInJson={props.data.outputResults} serviceId={fid} appId={id}></DownloadableFileListComponent>
                </ExpandableSection>
                
        }
        {
            isQSReport? <Button
            variant='inline-icon'
            iconName='view-full'
            onClick={() => {
                gotoDetails(props.data)
            }
            }> </Button>:
        <></>
        }
        </SpaceBetween>
    }

    const outputIconOld = props => (
        <>{
            (props.data.bucketName && props.data.outputResultsS3) ? 
            <Button
                variant='inline-icon'
                iconName={props.data?.outputResultsS3?.includes(',')? 'folder': 'download'}
                onClick={() => {
                    downloadFile(props.data, 'outputResultsS3')
                }
                }> </Button>:
            <></>
        }
        {
            (props.data.outputResults) ? 
            <Button
                variant='inline-icon'
                iconName='view-full'
                onClick={() => {
                    gotoDetails(props.data)
                }
                }> </Button>:
            <></>
        }
        </>
        
        
    )

    const epochToTimestamp = props => (
        <Box>{ convertEpochToLocal(Number(props.data.uploadedTimestamp)) }</Box>
    )
    const epochToTimestampLastUpdatedTime = props => (
        <Box>{ convertEpochToLocal(Number(props.data.lastUpdatedTimestamp)) }</Box>
    )
    const epochToTimestampJobModificationTime = props => (
        <Box>{ convertEpochToLocal(Number(props.data.jobStatusModificationTimestamp)) }</Box>
    )

    const epochToTimestampApprovalRequestedTime = props => (
        props.data?.approvalRequestedTime?
        <Box>{ convertEpochToLocal(Number(props.data?.approvalRequestedTime)) }</Box>:
        <Box></Box>
    )

    const epochToTimestampApprovalModificationTime = props => (
        props.data?.approvalModificationTime?
        <Box>{ convertEpochToLocal(Number(props.data?.approvalModificationTime)) }</Box>:
        <Box></Box>
    )
    
    const processImg = (props) => (
        <Box float="left">
          <img
            alt=""
            className="rounded-circle"
            src={
              "https://badgephotos.corp.amazon.com/?uid=" +
              props.data.uploadedBy
            }
            width={20}
            height={20}
          />
          &nbsp;
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={"https://phonetool.amazon.com/users/" + props.data.uploadedBy}
          >
            {props.data.uploadedBy}
          </a>
        </Box>
      );

    const  processImgApprovedBy = (props) => (
        props.data.approvedBy ? <Box float="left">
          <img
            alt=""
            className="rounded-circle"
            src={
              "https://badgephotos.corp.amazon.com/?uid=" +
              props.data.approvedBy
            }
            width={20}
            height={20}
          />
          &nbsp;
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={"https://phonetool.amazon.com/users/" + props.data.approvedBy}
          >
            {props.data.approvedBy}
          </a>
        </Box> : <Box></Box>
      );

    
    const parametersButton = (props) => {
        return props.data?.parameters? <Button onClick={() => {
        setParametersVisible(true)
        setParametersModalData(JSON.stringify(JSON.parse(props.data?.parameters), 0, 2))
        setModalLoading(false)
        }}>view</Button>:''
    }

    const resubmitButton = (cellProps) => {
        const handleResubmit = () => {
            configureFlexicoAppSync()
            getFlexicoTransaction(cellProps.data.fileId, function onSuccess(result) {
                const transaction = result.data.getFlexicoTransaction
                let rawParams = {}

                if (transaction?.plainParameters) {
                    try {
                        rawParams = JSON.parse(transaction.plainParameters)
                    } catch (e) {'Failed to parse plainParameters: ', e}
                }
                if (Object.keys(rawParams).length === 0 && transaction?.parameters) {
                    try {
                        const glueParams = JSON.parse(transaction.parameters)
                        for (let key in glueParams) {
                            rawParams[key.replace(/^--/, '')] = glueParams[key]
                        }
                    } catch (e) {'Failed to parse parameters: ', e}
                }

                dispatch(setRerunData({ ...rawParams, __rerunFileId: cellProps.data.fileId }))
                const executeTab = props.selectedSidebarContent?.find(
                    tab => tab.label.toLowerCase() === 'execute'
                )
                if (executeTab && executeTab.action) {
                    executeTab.action()
                }
            }, function onFailure() {
                console.error('Could not fetch transaction for re-run:', cellProps.data.fileId)
            })
        }
        return <Button variant="normal" onClick={handleResubmit}>re-run</Button>
    }

    const approvalStatusButton = (props) => {
        if (props?.data.approvalStatus == 'pending') {
            return <Link external href={`/ApprovalsHome/Workflow/${props.data.approvalId}`}> <span className='orange_badge' >{props.data.approvalStatus}</span> </Link>
        } else if (props.data.approvalStatus == 'completed') {
            return <Link external href={`/ApprovalsHome/Workflow/${props.data.approvalId}`}> <span className='green_badge' >{props.data.approvalStatus}</span> </Link>
        } else if (props.data.approvalStatus == 'rejected') {
            return <Link external href={`/ApprovalsHome/Workflow/${props.data.approvalId}`}> <span className='red_badge' >{props.data.approvalStatus}</span> </Link>
        } else if (props.data.approvalStatus == 'cancelled') {
            return <Link external href={`/ApprovalsHome/Workflow/${props.data.approvalId}`}> <span className='grey_badge' >{props.data.approvalStatus}</span> </Link>
        } else if (props.data.approvalStatus == 'NO APPROVAL') {
            return <span className='blue_badge' >{props.data.approvalStatus}</span>
        } else {
            if (props.data.approvalId) {
                return <Link external href={`/ApprovalsHome/Workflow/${props.data.approvalId}`}> <span className='blue_badge' >{props.data.approvalStatus}</span> </Link>
            } else {
                return <span className='blue_badge' >{props.data.approvalStatus}</span>
            }
        }
    }

    const reviewStatusButton = (props) => {
        if (props?.data.reviewStatus == 'pending') {
            return <Link external href={`/ApprovalsHome/Workflow/${props.data.reviewId}`}> <span className='orange_badge' >{props.data.reviewStatus}</span> </Link>
        } else if (props.data.reviewStatus == 'completed') {
            return <Link external href={`/ApprovalsHome/Workflow/${props.data.reviewId}`}> <span className='green_badge' >{props.data.reviewStatus}</span> </Link>
        } else if (props.data.reviewStatus == 'rejected') {
            return <Link external href={`/ApprovalsHome/Workflow/${props.data.reviewId}`}> <span className='red_badge' >{props.data.reviewStatus}</span> </Link>
        } else if (props.data.reviewStatus == 'cancelled') {
            return <Link external href={`/ApprovalsHome/Workflow/${props.data.reviewId}`}> <span className='grey_badge' >{props.data.reviewStatus}</span> </Link>
        } else if (props.data.reviewStatus == 'NO REVIEW') {
            return <span className='blue_badge' >{props.data.reviewStatus}</span>
        } else {
            if (props.data.reviewId) {
                return <Link external href={`/ApprovalsHome/Workflow/${props.data.reviewId}`}> <span className='blue_badge' >{props.data.reviewStatus}</span> </Link>
            } else if(props.data.reviewStatus) {
                return <span className='blue_badge' >{props.data.reviewStatus}</span>
            }else {
                return <span></span>
            }
        }
    }

    const postProcessingApprovalStatusButton = (props) => {
        if (props?.data.rippleApprovalStatus == 'pending') {
            return <Link external href={`/ApprovalsHome/Workflow/${props.data.rippleApprovalId}`}> <span className='orange_badge' >{props.data.rippleApprovalStatus}</span> </Link>
        } else if (props.data.rippleApprovalStatus == 'completed') {
            return <Link external href={`/ApprovalsHome/Workflow/${props.data.rippleApprovalId}`}> <span className='green_badge' >{props.data.rippleApprovalStatus}</span> </Link>
        } else if (props.data.rippleApprovalStatus == 'rejected') {
            return <Link external href={`/ApprovalsHome/Workflow/${props.data.rippleApprovalId}`}> <span className='red_badge' >{props.data.rippleApprovalStatus}</span> </Link>
        } else if (props.data.rippleApprovalStatus == 'cancelled') {
            return <Link external href={`/ApprovalsHome/Workflow/${props.data.rippleApprovalId}`}> <span className='grey_badge' >{props.data.rippleApprovalStatus}</span> </Link>
        } else if (props.data.rippleApprovalStatus == 'NO APPROVAL') {
            return <span className='blue_badge' >{props.data.rippleApprovalStatus}</span>
        } else {
            if (props.data.rippleApprovalId) {
                return <Link external href={`/ApprovalsHome/Workflow/${props.data.rippleApprovalId}`}> <span className='blue_badge' >{props.data.rippleApprovalStatus}</span> </Link>
            } else {
                return <span  >{props.data.rippleApprovalStatus || '-'}</span>
            }
        }
    }
    const fileDetails = props => (
         <>
            <CopyToClipboard
            copyButtonAriaLabel="Copy file id"
            copyErrorText="file id failed to copy"
            copySuccessText="file id copied"
            textToCopy={props.data.fileId}
            variant="icon"
            />
            <Link href={`/flexico/file/${props.data.fileId}`}>{props.data.fileId} </Link>
         </>
        )

    const getValueOrDefault = (params, field, defaultValue = "-") => {
        if (params.data == null) return '';
        return params.data[field] || defaultValue;
    };

    const getTimestampValue = (params, field) => {
        if (params.data == null) return '';
        return params.data?.[field] ? convertEpochToLocal(Number(params.data[field])) : "-";
    };

    const getDirectTimestampValue = (params, field) => {
        if (params.data == null) return '';
        return convertEpochToLocal(Number(params.data[field]));
    };

    const defaultColumnDefs = [
        { field: 'lastUpdatedTimestamp', width: 250, headerName: 'Last updated (Local)', sortable: true,  cellRenderer: epochToTimestampLastUpdatedTime, resizable: true, valueGetter: (params) => getDirectTimestampValue(params, 'lastUpdatedTimestamp') },
        { field: 'uploadedTimestamp', width: 250,  headerName: 'Uploaded time (Local)', sortable: true, cellRenderer: epochToTimestamp, resizable: true, valueGetter: (params) => getDirectTimestampValue(params, 'uploadedTimestamp') },
        { field: 'Input', width: 250, autoHeight: true,cellRenderer: downloadIcon },
        { field: 'Output', width: 250, autoHeight: true, cellRenderer: outputIcon },
        { field: 'uploadedBy', width: 150, headerName: 'Uploaded by', cellRenderer:processImg, sortable: true, resizable: true, valueGetter: (params) => getValueOrDefault(params, 'uploadedBy') },
        { field: 'status', width: 200, headerName: 'Status', sortable: true, resizable: true, valueGetter: (params) => getValueOrDefault(params, 'status') },
        { field: 'notice', width: 200, headerName: 'Notice', sortable: true, resizable: true },
        { field: 'approvalStatus', width: 200, headerName: 'Approval status', cellRenderer:approvalStatusButton, sortable: true, resizable: true, valueGetter: (params) => getValueOrDefault(params, 'approvalStatus') },
        { field: 'approvalStatusPp', width: 200, headerName: 'Post process Approval status', cellRenderer:postProcessingApprovalStatusButton, sortable: true, resizable: true, valueGetter: (params) => getValueOrDefault(params, 'rippleApprovalStatus') },
        { field: 'approvedBy', width: 150, headerName: 'Approved by', cellRenderer:processImgApprovedBy, sortable: true, resizable: true, valueGetter: (params) => getValueOrDefault(params, 'approvedBy') },
        { field: 'review', width: 200, headerName: 'Review on results', cellRenderer:reviewStatusButton, sortable: true, resizable: true, valueGetter: (params) => getValueOrDefault(params, 'reviewStatus') },
        { field: 'approvalRequestedTime', width: 250, headerName: 'Approval requested (Local)', cellRenderer: epochToTimestampApprovalRequestedTime,sortable: true, resizable: true, valueGetter: (params) => getTimestampValue(params, 'approvalRequestedTime') },
        { field: 'approvalModificationTime', width: 250, headerName: 'Approval modification time (Local)',cellRenderer: epochToTimestampApprovalModificationTime, sortable: true, resizable: true, valueGetter: (params) => getTimestampValue(params, 'approvalModificationTime') },
        { field: 'jobStartTime', width: 250, headerName: 'Job start time', sortable: true, resizable: true, valueGetter: (params) => getValueOrDefault(params, 'jobStartTime') },
        { field: 'parameters', width: 120,  headerName: 'parameters',sortable: true, resizable: true, cellRenderer: parametersButton },
        { field: 're-run', width: 130, headerName: 'Re-run', sortable: false, resizable: true, cellRenderer: resubmitButton },
        { field: 'file id', width: 350,cellRenderer: fileDetails,  headerName: 'file id',sortable: true, resizable: true, valueGetter: (params) => getValueOrDefault(params, 'fileId') },
    ];
    const [columnDefs, setColumnDefs] = useState(defaultColumnDefs)

    const defaultColDef = {
        // set filtering on for all columns
        filter: true,
        filterParams: {
            buttons: ["reset"],
            debounceMs: 200,
        }
    };

    const getMainMenuItems = useCallback((params) => {
    return [
      ...params.defaultItems,
      "separator",
      {
        name: "Rename column name",
        action: () => {
          // Save current column state before opening modal to prevent position reset
          setRenameModalObj({original: params.column, new: params.column.colDef.headerName || params.column.colDef.field, preState: {state: gridRef.current.api.getColumnState()}})
        }
      },
    ];
  }, []);
  
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));


    const checkAdminStatus = async () => {
        let isAdmin = await checkIfPortalAdmin(userId, currentStage) || await checkIfSupportAdmin(userId, currentStage);
        setIsAdminUser(isAdmin);
    };

    const handleAccess = async (data) => {
        let resp = false
        if (data[FLEXICO_TEMPLATE_KEYS.created_by] == userId) {
            resp = true
        } else {
            const isCorpApp = currentAppId == appSettings[currentStage]['appId']
            const viewAs = getParam('view_as')

            // Fire portal/support admin checks in parallel
            const [portalAdmin, supportAdmin] = await Promise.all([
                checkIfPortalAdmin(userId, currentStage),
                checkIfSupportAdmin(userId, currentStage)
            ])
            resp = portalAdmin || supportAdmin

            // temporary if condition for internal testing - the portal/support admin conditions are ignored for CRA app to simulate normal acc users permissions
            if (isCorpApp) resp = false

            if (!resp) {
                // Fire all remaining checks in parallel
                const [corpAdminResp, corpViewerResp, uploaderResp, approverResp] = await Promise.all([
                    isCorpApp ? isCorpAdmin(userId, currentAppId, currentStage) : Promise.resolve(null),
                    // Use "view as" as app_functionality_key
                    // This avoids us having to map corp_reporting view ids -> app functionality key when we want to determine viewer access
                    isCorpApp && viewAs ? isCorpViewer(userId, currentAppId, currentStage, viewAs) : Promise.resolve(null),
                    isUploaderAllowed(data, userId, currentStage),
                    isApprover(data, userId, currentStage)
                ])
                resp = (corpAdminResp?.['admin']) || corpViewerResp || uploaderResp || approverResp
            }
        }

        setIsAuthorised(resp)
        setIsCheckingAccess(false)
    }

    const loadData = async () => {
        const pageLoadTime = createKatalTimerStopWatch("timeTaken")
        try {
        setShowLoadingIcon(true)

        await Promise.all([
        new Promise((resolve, reject) => {
            getFlexicoTemplate(
            fid,
            async function onSuccess(response) {
                try {
                let res = response.data.getFlexicoTemplateRDS;
                setFlexicoTemplateData(res);
                await handleAccess(res);
                await checkAdminStatus();
                resolve();
                setShowLoadingIcon(false);
                } catch (e) {
                reject(e);
                }
            },
            function onFailure(response) {
                setShowLoadingIcon(false);
                setErrorMessage("Could not load template information");
                reject(response);
            }
            );
        }),

        new Promise((resolve, reject) => {
            listFlexicoTransactionsByFlexIdAll(
            id,
            fid,
            10000,
            null,
            function onSuccess(results) {
                setTransactions(results);
                results.sort(function (a, b) {
                var dateA = new Date(Number(a.lastUpdatedTimestamp)),
                    dateB = new Date(Number(b.lastUpdatedTimestamp));
                return dateB - dateA;
                });
                setItems(results);
                resolve();
            }
            );
        })
        ]);
            } finally {
        if(!pageLoadTime.isStopped) {
            stopAndCaptureTimeMetricsWithBasicAttributes(pageLoadTime, userId, `${ln.pathname}${location.search}`,ACTION_METHODS.PAGE_LOAD_TIME , SITE_SERVICES.FLEXICO)
        }
    }
    
}

    const getParam= (key) => {
        const search = props?.location?.search;
        const params = new URLSearchParams(search);
        const value = params.get(key);
        return value;
      }

    const getTemplateDisplayName = () => {
        const aliasParam = getParam('alias');
        return getDisplayName(aliasParam, flexicoTemplateData[FLEXICO_TEMPLATE_KEYS.template_name], flexicoTemplateData[FLEXICO_TEMPLATE_KEYS.label]);
    }

    const loadColumnPreferences = (onSuccess, onError) => {
        if (!fid) {
            onSuccess(null);
            return;
        }
        
        listPreference(
            fid,                        
            'FLEXICO',                  
            'HISTORY_COLUMN_PREF',      
            function onSuccessResponse(response) {
                const preferences = response?.data?.listPreference?.items || [];
                
                const validPreferences = preferences.filter(pref => {
                    if (pref.information) {
                        const information = typeof pref.information === 'string'
                            ? JSON.parse(pref.information)
                            : pref.information;
                        return information;
                    }
                    return false;
                });

                if (validPreferences.length > 0) {
                    const firstPreference = validPreferences[0];
                    setFullPreferenceObject(firstPreference);
                    const information = JSON.parse(firstPreference.information);
                    onSuccess(information);
                } else {
                    setFullPreferenceObject(null);
                    onSuccess(null);
                }
            },
            function onFailureResponse(error) {
                setFullPreferenceObject(null);
                onError(error);
            }
        );
    };

    const saveColumnPreferences = (state, columnDefinition) => {
        if (!fid || !state) return;

        setColumnPreferenceError("");
        setIsSavingColumnPreferences(true);

        const label = `Column preferences for Flexico ${fid}`;
        const information = {
            columnState: state,
            columnDefinition: columnDefinition
        };
        
        if (fullPreferenceObject?.preferenceId) {
            updatePreference(
                fullPreferenceObject.preferenceId,
                label,
                userId,
                information,
                () => {
                    setHasColumnChanges(false);
                    setIsSavingColumnPreferences(false);
                },
                (error) => {
                    console.error('Error updating column preferences:', error);
                    const errorMessage = error?.errors?.[0]?.message || error?.message || "Failed to save column preferences";
                    setColumnPreferenceError(errorMessage);
                    setIsSavingColumnPreferences(false);
                }
            );
        } else {
            const newPreferenceId = uuidv4();
            createPreference(
                newPreferenceId,
                'HISTORY_COLUMN_PREF',
                label,
                fid,                 
                'FLEXICO',           
                userId,
                information,
                null,              
                (response) => {
                    const newPreference = {
                        preferenceId: newPreferenceId,
                        label: label,
                        associationId: fid,
                        associationIdType: 'FLEXICO',
                        preferenceType: 'HISTORY_COLUMN_PREF',
                        createdBy: userId,
                        lastUpdatedBy: userId,
                        lastUpdatedTimestamp: Date.now().toString(),
                        information: information
                    };
                    setFullPreferenceObject(newPreference);
                    setHasColumnChanges(false);
                    setIsSavingColumnPreferences(false);
                },
                (error) => {
                    console.error('Error creating column preferences:', error);
                    const errorMessage = error?.errors?.[0]?.message || error?.message || "Failed to save column preferences";
                    setColumnPreferenceError(errorMessage);
                    setIsSavingColumnPreferences(false);
                }
            );
        }
    };

    const DISPLAY_PARAM_PREF_TYPE = 'FLEXICO_DISPLAY_PARAMS';

    const loadDisplayParamPreferences = (onSuccess) => {
        if (!fid) { onSuccess([]); return; }
        listPreference(fid, 'FLEXICO', DISPLAY_PARAM_PREF_TYPE,
            (response) => {
                const prefs = response?.data?.listPreference?.items || [];
                if (prefs.length > 0) {
                    setDisplayParamPreferenceObject(prefs[0]);
                    const info = typeof prefs[0].information === 'string' ? JSON.parse(prefs[0].information) : prefs[0].information;
                    onSuccess(info?.displayParameters || []);
                } else {
                    setDisplayParamPreferenceObject(null);
                    onSuccess([]);
                }
            },
            () => onSuccess([])
        );
    };

    const saveDisplayParamPreferences = (selected) => {
        const label = `Display params for Flexico ${fid}`;
        const information = { displayParameters: selected };
        if (displayParamPreferenceObject?.preferenceId) {
            updatePreference(displayParamPreferenceObject.preferenceId, label, userId, information, () => {}, () => {});
        } else {
            const newId = uuidv4();
            createPreference(newId, DISPLAY_PARAM_PREF_TYPE, label, fid, 'FLEXICO', userId, information, null,
                () => setDisplayParamPreferenceObject({ preferenceId: newId, associationId: fid, associationIdType: 'FLEXICO', preferenceType: DISPLAY_PARAM_PREF_TYPE }),
                () => {}
            );
        }
    };

    const buildParamColumnDefs = (paramLabels, templateData) => {
        return paramLabels.map(label => {
            const param = templateData?.parameters?.find(p => p.label === label);
            return {
                field: `param_${label}`,
                headerName: param?.display_name || label,
                width: 180,
                sortable: true,
                resizable: true,
                valueGetter: (params) => {
                    try {
                        if (params.data?.plainParameters) {
                            const parsed = JSON.parse(params.data.plainParameters);
                            const val = parsed[label];
                            if (val !== undefined) return Array.isArray(val) ? val.join(', ') : val;
                        }
                        if (params.data?.parameters) {
                            const parsed = JSON.parse(params.data.parameters);
                            const val = parsed[`--${label}`];
                            if (val !== undefined) return Array.isArray(val) ? val.join(', ') : val;
                        }
                    } catch { }
                    return '';
                }
            };
        });
    };

    useEffect(() => {
        const paramsKey = JSON.stringify(displayParameters);
        // Use template id as a stable identity key for flexicoTemplateData
        const templateId = flexicoTemplateData?.flex_id || flexicoTemplateData?.id || null;
        
        // Skip if neither displayParameters nor the template has actually changed since the last run.
        // This prevents this effect from wiping the saved column order after handleSaveColumnLayout
        // calls setColumnDefs, which would otherwise trigger a re-render and re-run this effect.
        if (prevDisplayParamsRef.current.params === paramsKey && prevDisplayParamsRef.current.templateId === templateId) return;
        prevDisplayParamsRef.current = { params: paramsKey, templateId };
        
        if (displayParameters.length > 0 && flexicoTemplateData?.parameters) {
            // Build param_* column defs for each selected display parameter and append them,
            // removing any stale param_* columns first to avoid duplicates
            const paramCols = buildParamColumnDefs(displayParameters, flexicoTemplateData);
            setColumnDefs(prev => [
                ...prev.filter(c => !c.field?.startsWith('param_')),
                ...paramCols
            ]);
        } else {
            // No display parameters selected — strip any param_* columns from the grid
            setColumnDefs(prev => prev.filter(c => !c.field?.startsWith('param_')));
        }
    }, [displayParameters, flexicoTemplateData]);

    const handleColumnEvent = () => {
        if (isInitialLoadComplete) {
            setHasColumnChanges(true);
        }
    };

    const handleColumnVisibilityEvent = () => {
        if (isInitialLoadComplete) {
            setHasColumnChanges(true);
        }
    };

    const onGridReady = (params) => {
        setIsInitialLoadComplete(true);
    };

    const handleSaveColumnLayout = () => {
        if (gridRef.current?.api) {
            // Capture current column order, widths, visibility, and pinning from ag-grid
            const currentState = gridRef.current.api.getColumnState();
            // Rebuild column defs in the current grid order, excluding hidden columns
            const updatedColumnDefs = currentState
                .filter(col => !col.hide)
                .map(colState => {
                    const baseColDef = defaultColumnDefs.find(defCol => defCol.field === colState.colId);
                    const currentColDef = gridRef.current.api.getColumnDefs()?.find(def => def.field === colState.colId);
                    if (baseColDef) {
                        // Merge saved width/headerName overrides onto the base column definition
                        return mergeColumnStateAndDef(baseColDef, currentColDef);
                    }
                    // param_* columns are not in defaultColumnDefs — carry them through as-is to preserve position
                    return currentColDef || null;
                })
                .filter(Boolean);
            
            setColumnDefs(updatedColumnDefs);
            // Persist both column order (state) and column definitions (widths, headerNames) to the server
            saveColumnPreferences(currentState, gridRef.current.api.getColumnDefs());
        }
    };
    const resetColumnlayout = () => {
        if (gridRef.current?.api) {
            setColumnPreferenceError("");
            setIsResetting(true);
            
            // Defer to allow any in-flight ag-grid column events to settle before applying state
            setTimeout(() => {
                // Build the default ag-grid column state from defaultColumnDefs (all visible, no pinning/sorting)
                const defaultState = defaultColumnDefs.map((col, index) => ({
                    colId: col.field,
                    hide: false,
                    pinned: null,
                    sort: null,
                    sortIndex: null,
                    aggFunc: null,
                    width: col.width ? parseInt(col.width) : undefined,
                    flex: null,
                    rowGroupIndex: null,
                    pivotIndex: null
                }));
                
                gridRef.current.api.applyColumnState({
                    state: defaultState,
                    applyOrder: true
                });
                
                // Re-append any active param_* columns after reset so they are not lost
                const paramCols = displayParameters.length > 0 && flexicoTemplateData?.parameters
                    ? buildParamColumnDefs(displayParameters, flexicoTemplateData)
                    : [];
                setColumnDefs([...defaultColumnDefs, ...paramCols]);
                setHasColumnChanges(true);
                setIsResetting(false);
            }, 300); 
        }
    };

    const saveRenameColumn = (renameObj) => {
        if (!renameObj || !renameObj.new || !renameObj.original) {
            return;
        }
        
        const newHeaderName = renameObj.new.trim();
        if (newHeaderName === '') {
            return;
        }

        gridRef.current.api.applyColumnState({
                    state: renameModalObj.preState.state,
                    applyOrder: true
                });

        // Update the column definition with new header name
        const updatedColumnDefs = gridRef?.current.api.getColumnDefs().map(colDef => {
            if (colDef.field === renameObj.original.colDef.field) {
                return {
                    ...colDef,
                    headerName: newHeaderName
                };
            }
            return colDef;
        });

        // Update the column definitions state - React will automatically re-render the grid
        setColumnDefs(updatedColumnDefs);

        // Mark that changes have been made
        setHasColumnChanges(true);
        
        // Close the rename modal
        setRenameModalObj(null);
    };

    const content = (
        <div>
            {
                isAuthorised?
                <Box>
                    <SpaceBetween size='l'>
                    <Container
                        header={
                            <Header
                                variant='h2'
                                actions={
                                    <SpaceBetween direction="horizontal" size="xs">
                                        <Button variant='normal' onClick={() => { 
                                            if (props.selectedSidebarContent) {
                                                const executeTab = props.selectedSidebarContent.find(
                                                    tab => tab.label.toLowerCase() === 'execute'
                                                );
                                                
                                                if (executeTab && executeTab.action) {
                                                    executeTab.action();
                                                } else {
                                                    history.push(`/App/${id}/flexico/${fid}/upload${location.search}`);
                                                }
                                            } else {
                                                history.push(`/App/${id}/flexico/${fid}/upload${location.search}`);
                                            }
                                        }}>
                                            Execute
                                        </Button>
                                    </SpaceBetween>
                                }
                                description=""
                            >Execute job for template - {getTemplateDisplayName()}


                            </Header>
                        }
                    >
                    </Container>

                        <Container
                            header={
                                <Header
                                    variant='h2'
                                    actions={
                                        <SpaceBetween direction="horizontal" size="xs">
                            {hasColumnChanges && isAdminUser && (
                                <Button 
                                    variant='primary' 
                                    onClick={handleSaveColumnLayout}
                                    loading={isSavingColumnPreferences}
                                    disabled={isSavingColumnPreferences || isResetting}
                                >
                                    Save view
                                </Button>
                            )}
                                             <Button 
                                                variant='link' 
                                                onClick={resetColumnlayout}
                                                loading={isResetting}
                                                disabled={isSavingColumnPreferences || isResetting}
                                            >
                                                Reset view
                                            </Button>
                                            <Button variant='normal' iconName='refresh' onClick={loadData}></Button>
                                        </SpaceBetween>
                                    }
                                    description="The following table shows all the executions."
                                >Execution history
                                    {showLoadingIcon ?
                                        <Spinner size='normal'></Spinner> : <div></div>
                                    }

                                </Header>
                            }
                            fitHeight
                        >
                            {columnPreferenceError && (
                                <Box margin={{ bottom: "s" }}>
                                    <StatusIndicator type="error">{columnPreferenceError}</StatusIndicator>
                                </Box>
                            )}
                            <div
                                className="ag-theme-alpine"
                                    style={{ height: 400, width: "100%" }}
                                >
                                    <AgGridReact
                                        ref={gridRef}
                                        rowData={items}
                                        defaultColDef={defaultColDef}
                                        columnDefs={columnDefs}
                                        rowSelection='single'
                                        animateRows={true}
                                        rowHeight={40}
                                        enableCellTextSelection={true}
                                        onColumnMoved={handleColumnEvent}
                                        onColumnVisible={handleColumnVisibilityEvent}
                                        onGridReady={onGridReady}
                                        getMainMenuItems={getMainMenuItems}
                                        pagination={true}
                                        paginationPageSize={20}
                                        paginationPageSizeSelector={[10, 20, 50, 100]}
                                        suppressPaginationPanel={false}
                                    >
                                    </AgGridReact>
                                </div>
                            </Container>
                    </SpaceBetween>
                    <Modal
                onDismiss={() => {
                    setParametersVisible(false)
                    setParametersModalData('')
                }}
                visible={parametersVisible}
                size="max"
                footer={
                    <Box float="right">
                        <SpaceBetween direction="horizontal" size="xs">
                            <Button variant="primary" onClick={() => {
                                setParametersVisible(false)
                                setParametersModalData('')
                            }}>
                                Close
                            </Button>
                        </SpaceBetween>
                    </Box>
                }
            >
                <CodeView
      content={parametersModalData}
    />
            </Modal>
            <Modal
                onDismiss={() => {
                    setRenameModalObj(null)
                }}
                visible={renameModalObj}
                footer={
                    <Box float="right">
                        <SpaceBetween direction="horizontal" size="xs">
                            <Button variant="primary" onClick={() => {
                                saveRenameColumn(renameModalObj)
                            }}>
                                Save
                            </Button>
                            <Button  onClick={() => {
                                setRenameModalObj(null)
                            }}>
                                Close
                            </Button>
                        </SpaceBetween>
                    </Box>
                }
                header={`Rename column ${renameModalObj?.original.colDef.headerName || renameModalObj?.original.colDef.field}`}
                >

                <Input
      onChange={({ detail }) => setRenameModalObj({...renameModalObj, new: detail.value})}
      value={renameModalObj?.new}
    />

            </Modal>
                    </Box> : isCheckingAccess ? <div>
                        <WaitForPageAccess></WaitForPageAccess>
                    </div> :
                        <Alert
                            statusIconAriaLabel="Error"
                            type="error"
                            header="Access denied"
                        >
                             {
                                id == appSettings[currentStage]['appId'] ?
                                "You don't have permission to view the history. You are not part of the Uploader/Approver group for this deliverable  If you believe you should have access please contact the SEC team to request membership in the appropriate group":
                                "No access to view"

                            }
                        </Alert>
            }
        </div>
    )


    return (
        <AppLayout
            content={content}
            navigation={<SideNav activeHref={`/App/${id}/flexico/${fid}/history`} id={id} fid={fid} process={flexicoTemplateData} back={backUrl}/> }
            headerSelector="#TopBar"
            navigationHide={props.disableAppLayout}
            disableBodyScroll={true}
            toolsHide={true}
            headerVariant="high-contrast"
        ></AppLayout>
    )
}



export default FlexicoHistory
